import { Autocomplete, FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";
import type { CreateIntegrationRequest } from "../../../../common/interfaces/admin/integration.interface";

export interface KnowledgeBaseOption {
    uid: string;
    label: string;
}

export interface IntegrationBasicsStepProps {
    value: Pick<
        CreateIntegrationRequest,
        "name" | "knowledgeBaseUid" | "linkEnabled" | "widgetEnabled"
    >;
    onChange(patch: Partial<IntegrationBasicsStepProps["value"]>): void;
    knowledgeBases: KnowledgeBaseOption[];
    knowledgeBaseLocked?: boolean;
}

export default function IntegrationBasicsStep({
    value,
    onChange,
    knowledgeBases,
    knowledgeBaseLocked
}: IntegrationBasicsStepProps) {
    const selectedKb = knowledgeBases.find(kb => kb.uid === value.knowledgeBaseUid) ?? null;

    return (
        <div className="integration-step">
            <TextField
                label="Name"
                fullWidth
                required
                inputProps={{ maxLength: 120 }}
                value={value.name}
                onChange={e => onChange({ name: e.target.value })}
                helperText="Internal label — not shown to end users."
            />

            <Autocomplete
                disabled={knowledgeBaseLocked}
                options={knowledgeBases}
                getOptionLabel={o => o.label}
                isOptionEqualToValue={(o, v) => o.uid === v.uid}
                value={selectedKb}
                onChange={(_, next) => onChange({ knowledgeBaseUid: next?.uid ?? "" })}
                renderInput={params => (
                    <TextField
                        {...params}
                        label="Assistant"
                        required
                        helperText={
                            knowledgeBaseLocked
                                ? "Assistant is fixed after the integration is created."
                                : "Which Assistant this integration exposes."
                        }
                    />
                )}
            />

            <FormGroup>
                <FormControlLabel
                    control={
                        <Switch
                            checked={value.linkEnabled ?? false}
                            onChange={(_, v) => onChange({ linkEnabled: v })}
                        />
                    }
                    label="Enable shareable link surface"
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={value.widgetEnabled ?? false}
                            onChange={(_, v) => onChange({ widgetEnabled: v })}
                        />
                    }
                    label="Enable widget (script) surface"
                />
            </FormGroup>
        </div>
    );
}
